"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StacksNetwork = void 0;
const network_1 = require("@stacks/network");
exports.StacksNetwork = {
    mainnet: new network_1.StacksMainnet(),
    testnet: new network_1.StacksTestnet(),
};
//# sourceMappingURL=api.types.js.map